import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FaDownload, FaFilePdf } from "react-icons/fa";
import { openPdfInNewTab } from '../../CommonUtils/CommonServices';

export default function Affl_CdcOamdcReport2023() {
    const acYear = sessionStorage.getItem('ac_year');
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const handleNavigate = (collCode, instname, type) => {
        navigate('/AfflOrdVerif2021', {
            state: { type, instname, collCode }
        });
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };
    const ProeedConfirmdetailsFormik = useFormik({
        initialValues: {

            acYear: acYear,
        },
    })
    const [cdcengData23, setCdcengData23] = useState([]);
    function GetCdcEnggReport() {
        let url = config.url.API_URL + `cdcOamdcReport `;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCdcengData23(res?.data?.cdcOamdcReport);
            } else {
                setCdcengData23([])
            }
        })
    }

    // function GetClgSubmissionPdf(collCode) {
    //     navigate("/AfflDegreeReport");
    //     dispatch({ type: "COLLEGE_CODE", payload: collCode });
    // }
    function GetClgSubmissionPdf(collCode) {
        let payload = {}
        let url = config.url.API_URL + `getdegreepdf/${collCode}/${acYear}`
        CommonAxiosPost(url, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }



    function GetMobileAppPhotos(collCode) {
        navigate("/AfflFfcaAppUploads");
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    }
    useEffect(() => {
        GetCdcEnggReport();
    }, [])

    const handleClick = (collCode) => {
        navigate("/AfflFfcaCommittePhoto");
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };


    function GetFfcaSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + acYear;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            } else {
                console.log("No Data Found")

            }
        })
    }



    function GetDeficienciesPdf(collCode) {
        let url = config.url.API_URL + `getafflfacultydef/pdf/` + collCode + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === 1) {
                openPdfInNewTab(res?.data?.data)
            } else {
                console.log("No Data Found")

            }
        })
    }
    const CourseDataReportColumns23 = [
        {
            Header: "Sl.No",
            accessor: (row, index) => index + 1,
        },
        {
            Header: "College Code",
            accessor: "coll_code",
        },

        {
            Header: "College Name",
            accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            )
        },

        {
            Header: "Course Conversion Order",
            accessor: "sanction_order_file",

            Cell: ({ row }) => {
                const file = row?.original?.sanction_order_file;

                if (!file) {
                    return <b style={{ textAlign: "center" }}>-</b>;
                }
                return (
                    <button
                        type="button"
                        className="btn btn btn-md pt-1"

                        onClick={() => {
                            viewImage(file);
                        }}
                    >
                        <FaDownload size={20} />
                    </button>
                );
            }
        },

        {
            Header: "ACITE Order",
            accessor: "aicte_order",
            Cell: ({ row }) => {
                const file = row?.original?.aicte_order;

                if (!file) {
                    return <b style={{ textAlign: "center" }}>-</b>;
                }
                return (
                    <button
                        type="button"
                        className="btn btn btn-md pt-1"

                        onClick={() => {
                            viewImage(file);
                        }}
                    >
                        <FaDownload size={20} />
                    </button>
                );
            }
        },
        {
            Header: "College Submission Pdf",
            accessor: "",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetClgSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }
        },
        {
            Header: "FFCA Submission Pdf",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetFfcaSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }

        },
        //ffca deficiencies  

        {
            Header: "FFCA Deficiencies",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetDeficienciesPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }

        },


        {
            Header: "Committee Photos",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1"
                        onClick={() => {
                            handleClick(row?.original?.coll_code);
                        }}>
                        view
                    </button>
                )
            }
        },
        {
            Header: "Mobile App Photos",
            accessor: "",

            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1"
                        onClick={() => {
                            GetMobileAppPhotos(row?.original?.coll_code);
                        }}>
                        view
                    </button>
                )
            }
        },
        {
            Header: "College Details Confirmation",
            accessor: "cdc_confirm",
            Cell: ({ row }) => {
                const value = row?.values?.cdc_confirm;
                if (value === "College Details Confirmation") {
                    return <button type='button' className='btn btn-primary rounded-pill btn-sm' onClick={() => { handleNavigate(row?.original?.coll_code, row?.original?.inst_name, "OAMDC") }}>  Confirm College Details</button>;
                } else {
                    return (
                        <button type="button" className="btn btn  btn-md pt-1"
                            onClick={() => {
                                viewImage(value);
                            }}>
                            <FaFilePdf color="red"
                                size={20} />
                        </button>
                    );
                }
            }
        },
    ]

    return (
        <>
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={ProeedConfirmdetailsFormik}>

                    <Form onChange={ProeedConfirmdetailsFormik?.handleChange} onSubmit={ProeedConfirmdetailsFormik?.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3 pb-3">
                            <CommonFormHeading heading={`College Details Confirmation-${acYear}`} />
                            {cdcengData23?.length > 0 ? (
                                <div className="table-responsive">
                                    <CommonReactTable data={cdcengData23} columns={CourseDataReportColumns23} pagination="false" filename="OAMDC CDC Colleges Confirmation" headerName={`OAMDC CDC Colleges Confirmation`} />
                                </div>
                            ) : <center className='text-danger h5 pt-5'>***** No Data Found *****</center>}
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>


        </>
    )
}
